import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ReactSession } from 'react-client-session';
import { useNavigate, useParams } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
ReactSession.setStoreType("localStorage");

function App() {
    
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [orderId, setOrderId] = useState('');
    const [trackingId, setTrackingId] = useState('');
    const [orderData, setOrderData] = useState('');
    const [trackData, setTrackData] = useState('');
    const [error, setError] = useState('');
    const [errors, setErrors] = useState('');
    const [currencyValue, setCurrencyValue] = useState(1);
    const [currencySymbol, setCurrencySymbol] = useState('₹');

    useEffect(() => {
        const intervalId = setInterval(() => {
            const cValue = sessionStorage.getItem('jmpiCurnceV');
            const cSymbol = sessionStorage.getItem('jmpiCurnceS');
            setCurrencyValue(cValue);
            setCurrencySymbol(cSymbol);
        }, 1000);
        return () => clearInterval(intervalId);
    },[]);
    


    const login = async (e) => {
     e.preventDefault();

     const loginData = {
        email: email,
        orderId : orderId
     }
     try{
        const response = await axios.post('https://demo.sninfoserv.com/api/tracking/orderid/', loginData);
        console.log(response.data);
        if(response.data.status === 'success'){
            setOrderData(response.data);
			setTrackData('');
			setError('');
			setErrors('');
        }else{
            setError(response.data.message);
			setErrors('');
			setOrderData('');
			setTrackData('');
        }

     }catch(error){
        setError({ error: error.message });
     }

    };
	
	const tracking = async (e) => {
     e.preventDefault();

     const loginData = {
        trackId : trackingId
     }
     try{
        const response = await axios.post('https://demo.sninfoserv.com/api/tracking/trackingid/', loginData);
        console.log(response.data);
        if(response.data.status === 'success'){
            setTrackData(response.data);
			setOrderData('');
			setError('');
			setErrors('');
        }else{
            setErrors(response.data.message);
			setError('');
			setTrackData('');
			setOrderData('');
        }

     }catch(error){
        setError({ error: error.message });
     }

    };
  
    return (
        <div class="page-wrapper">
          <h1 class="d-none">Jampani Pickles</h1>
          <Header />  
          <main class="main order">
           
          <nav class="breadcrumb-nav">
                <div class="container">
                    <ul class="breadcrumb">
                        <li><a href="/">Home</a></li>
                        <li>Track Orders</li>
                    </ul>
                </div>
            </nav>

            <div class="page-content" >
                <div class="container" style={{minHeight: '50vh'}}>
                    <div class="row mt-4 mb-4" style={{border: '1px solid #40a944', borderRadius: '10px'}}>
                        <div class="col-md-12 col-xl-5 col-xxl-5 mt-4 mb-4" style={{marginLeft: 'auto', marginRight: 'auto'}}>
                           
                            <form onSubmit={login} >  
                                <div class="row">
                                    <div class="col-xl-6 col-xxl-6 col-md-12 mt-4">
                                        <label>Email ID *</label>
                                        <input type="email" class="form-control"  required  value={email} onChange={(e)=>setEmail(e.target.value)} />
                                    </div>
                                    <div class="col-xl-6 col-xxl-6 col-md-12 mt-4">
                                        <label>Order ID *</label>
                                        <input type="text" class="form-control"  required value={orderId} onChange={(e)=> setOrderId(e.target.value)} />
                                    </div>
                                </div>
                                    
                                <button type="submit" class="btn btn-primary mt-4">Track Now</button>
                            </form>
                            <p class="text-danger" align="center">{error.length > 0 && error}</p>
                            {orderData && 
                                <p>
                                    <h3 style={{color: '#40a944'}}>{orderData.data[0].orderStatus}</h3>
									{orderData.data[0].courierPartner && <> <small style={{color: '#df3f00'}}>You can also track live status from <span class="text-primary">{orderData.data[0].courierPartner}</span>'s official website! with Tracking ID : <span class="text-primary">{orderData.data[0].trackingId}</span></small>< br /> </>}
                                    Placed on : <b>{orderData.data[0].time}</b> <br />
                                    Amount : <b>{currencySymbol} {Number(orderData.data[0].grandTotal).toFixed(2)}</b> <br />
                                    Items : <b> {orderData.data[0].Items}</b> <br />
                                    Payment ID : <b> {orderData.data[0].paymentId}</b> <br />
                                </p>
                            }
                        </div>

                        <div class="col-md-2 col-xl-2 col-xxl-2  mt-4 mb-4 ">
                            <div style={{width: '1px', background: 'grey', height: '100%', marginLeft: 'auto', marginRight: 'auto'}}></div>
                        </div>

                        <div class=" col-md-12 col-xl-5 col-xxl-5 mt-4 mb-4" style={{marginLeft: 'auto', marginRight: 'auto'}}>
                           
                           <form  onSubmit={tracking}>  
                               <div class="row">
                                   <div class="col-xl-12 col-xxl-12 col-md-12 col-sm-12 mt-4">
                                       <label>Tracking ID *</label>
                                       <input type="text" class="form-control"  required value={trackingId} onChange={(e)=> setTrackingId(e.target.value)} />
                                   </div>
                               </div>
                                   
                               <button type="submit" class="btn btn-primary mt-4">Track Now</button>
                           </form>
                           <p class="text-danger" align="center">{errors.length > 0 && errors}</p>
                           {trackData && 
                                <p>
                                    <h3 style={{color: '#40a944'}}>{trackData.data[0].orderStatus}</h3>
									<small style={{color: '#df3f00'}}>You can also track live status from {trackData.data[0].courierPartner}'s official website!</small>< br />
                                    Placed on : <b>{trackData.data[0].time}</b> <br />
                                    Amount : <b>{currencySymbol} {Number(trackData.data[0].grandTotal).toFixed(2)}</b> <br />
                                    Items : <b> {trackData.data[0].Items}</b> <br />
                                    Payment ID : <b> {trackData.data[0].paymentId}</b> <br />
                                </p>
                            }
                             
                       </div>

                    </div>
                </div>
            </div>
           
           </main>
          <Footer />
        </div>
  );
}

export default App;